// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1mSaJ","requiredAsterisk":"Info_requiredAsterisk__2qphH"};